import React, { useState } from 'react';
import Header from '../component/Header';
import Sidebar from '../component/Sidebar';
import data from '../component/data/specialist';



const Specialist = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    

    return (
        <div className='w-full flex items-start justify-center bg-[#F9FAFB] relative'>
            {/* Sidebar with conditional rendering for mobile */}
            <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block w-full lg:w-1/6 fixed left-0 top-0 h-full z-50`}>
                <Sidebar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
            </div>

            {/* Overlay for mobile when sidebar is open */}
            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={toggleSidebar}
                ></div>
            )}

            <div className='flex flex-col w-full space-y-4 lg:ml-[16.67%]'>
                <div>
                     <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} 
                     title='Specialists'
                     />  
                </div>

                <div className='p-4 lg:p-[30px]'>
                    <p className='font-semibold'>
                        Find here on our list a Specialist that suits your needs
                    </p>

                    <div className='w-full flex flex-col gap-4 
                  lg:grid lg:grid-cols-2'>
                    {data.map((item, index) => (
                        <div key={index} className='w-full flex flex-col border brorder-gray-300 rounded-lg bg-white text-sm
                        p-3  items-start
                        md:text-base'>
                            <div className='w-full flex items-center justify-between h-4/5'>
                                <div className='flex items-start w-full gap-4 '>
                                    <img src={item.profileImage} alt="" className='w-10 h-10'/>

                                    <div className='flex flex-col gap-1'>
                                        <p className='font-semibold'>
                                        {item.Name}
                                        </p>
                                        <p className='text-[#069125] font-semibold'>
                                        {item.Title}
                                        </p>
                                        <p className='text-gray-400'>
                                        {item.Message}
                                        </p>
                                    </div>
                                </div>

                            </div>

                           <button className='mt-3 bg-[#069125] text-white font-medium py-2 px-3 rounded-lg '>
                            Start a Consultation
                           </button>
                            
                           
                        </div>
                    ))}
                  </div>
                </div>
            </div>
        </div>
    );
};

export default Specialist;
